import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'insertPoint', 'nestedFields', 'orderInput', 'destroyInput', 'destroyTrigger', 'sortableRoot'
  ];

  static values = {
    prefix: String,
    templateHtml: String
  };

  initialize() {
    if (this.prefixValue === null) this.prefixValue = '';
    if (this.hasSortableRootTarget) this.initSortable();
  }

  // ACTIONS

  addFields() {
    const content = this.templateHtmlValue.replace(
      RegExp(`NEW_${this.prefixValue}_?RECORD`, 'gi'), new Date().getTime()
    );
    this.insertPointTarget.insertAdjacentHTML('beforeend', content);
    this.setOrder();
  }

  removeFields(e) {
    Array.from(this.destroyTriggerTargets).forEach((target, idx) => {
      if (e.target === target) {
        this.destroyFields(idx);
      }
    });
    this.setOrder();
  }

  updateOrder() {
    this.setOrder();
  }

  // PRIVATE

  destroyFields(idx) {
    const removedFields = this.nestedFieldsTargets[idx];
    if (removedFields.hasAttribute('data-new-record')) {
      removedFields.remove();
    } else {
      this.destroyInputTargets[idx].value = 1;
      removedFields.style.display = 'none';
    }
  }

  setOrder() {
    if (this.orderInputTargets.length === 0) return;
    Array.from(this.nestedFieldsTargets).forEach((_, idx) => {
      this.orderInputTargets[idx].value = idx;
    });
  }

  initSortable() {
    $(this.sortableRootTarget).sortable({
      update: () => this.dispatch('sorted'),
      axis: 'y',
      handle: '.js-handle',
      tolerance: 'pointer',
      placeholder: 'sortable-placeholder'
    });
  }
}
